import React from 'react';

const UiFilterChip = ({
  active = false,
  children,
  className = '',
  activeClassName = 'bg-primary-600 text-white',
  inactiveClassName = 'bg-gray-100 text-gray-700 hover:bg-gray-200',
  ...props
}) => {
  return (
    <button
      type="button"
      className={`flex flex-col items-center justify-center gap-1 whitespace-nowrap rounded-xl px-3 py-3 font-medium transition ${active ? activeClassName : inactiveClassName} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default UiFilterChip;
